export const pinResetEquipmentPortTypeConfig = ['IPVE'];



// WEBPACK FOOTER //
// ./src/constants/pinResetConfig.js